import * as React from "react";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";
import {modifyWhiteElement}            from "@Xpresso/routes/brand/branded-login/branded-login";
import {ID_COMPANY_KELLAR_WILLIAMS} from "@Xpresso/routes/brand/branded-login/branded-product/branded-product";
import "./branded-service.scss";

export const BrandedService = ({themeScheme}) => {
    const invert = modifyWhiteElement(themeScheme?.xpresso?.menuBackgroundColor)

    return (
        <div className="service-br3">
            <div className="service-grid">
                {
                    services.map((service, i) => (
                        <div
                            key={i} 
                            className="service-cell"
                            xd-qa-type="card"
                            xd-qa-name={"Service Card " + i}
                        >
                            <FontAwesomeIcon
                                icon={require('@fortawesome/free-solid-svg-icons')[service.icon]}
                                className={`icon-service-cell ${invert ? 'invert' : ''}`}
                                style={{
                                    color: themeScheme?.xpresso?.menuBackgroundColor
                                }}
                                xd-qa-type="icon"
                                xd-qa-name="Icon"
                            />
                            <div className="service-message">
                                <h4 xd-qa-type="label" xd-qa-name="Header">{service.header}</h4>
                                <p xd-qa-type="text" xd-qa-name="Text">{service.text}</p>
                            </div>
                        </div>
                    ))
                }
            </div>
            {
                themeScheme?.schemeLevelId === ID_COMPANY_KELLAR_WILLIAMS &&
                <div className="kw-special-container">
                    <p xd-qa-type="text" xd-qa-name="Subtext">{textKWSpecial}</p>
                </div>
            }
        </div>
    )
}

const service = (icon, header, text) => {
    return {
        "icon": icon,
        "header": header,
        "text": text
    }
}

const textMarketing = `Get miles ahead of the competition with a strong brand presence 
    on everything you share, using the Xpressdocs marketing platform!`

const textAudience = `Grow your recognition and credibility each and every time you deliver your 
    marketing into the hands of current and prospective customers.`

const textTemplates = `Custom marketing materials are brand enhancing and drive action. Our products
    are printed with unsurpassed quality on the most efficient presses.`

const textProcessing = `There's a reason we're called Xpressdocs. Our high-speed order processing
    ensures your order is shipped or mailed with superior velocity.`

const services = [
    service('faShieldHalved', 'The Power of Marketing', textMarketing),
    service('faFaceLaughBeam', 'Impress Your Audience', textAudience),
    service('faTable', 'Agency-Quality Templates', textTemplates),
    service('faTachometerAltFast', 'High-speed Order Processing', textProcessing)
]

const textKWSpecial = `Keller Williams Approved Vendor Program members are business entities independent from 
    Keller Williams Realty, Inc. Neither Keller Williams Realty, Inc. nor its affiliated companies warrant Xpressdocs, 
    its products, or its services.`
